import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { UPDATE_TENANT_INFO_BY_TENANT_ID, UPDATE_USER_INFO_BY_USER_ID } from 'graphql/service';
import { filterNonEmpty } from 'utils/util';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

/**
 * A custom hook for valid form
 * @param {Object} customerInfo - an object has customer information
 * @returns
 * customerInfo,
 * customerInfoError,
 * updateCustomerInfo
 */

export const useCustomerForm = (setCustomerInfoError) => {

  const customerInfo = useSelector(state => state.customerInfoReducer.customerInfo)

  const [updateUserInfoByUserId, { loading: updateUserInfoLoading }] = useMutation(
    UPDATE_USER_INFO_BY_USER_ID,
    {
      onCompleted: (updateUserInfoData)=> {
        if(updateUserInfoData?.updateUser?.id) {
          message.success('Tenant Info updated successfully!')  
        } else {
          const content = 'Update failed'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const [updateTenantInfoByTenantId] = useMutation(
    UPDATE_TENANT_INFO_BY_TENANT_ID
  )

  // //function for valid form, make sure nonempty field in the form
  // const isValidForm = () => {

  //   let result = true
  //   if (!customerInfo.streetAddress) {
  //     result = false;
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, streetAddressError: true}))
  //   } else {
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, streetAddressError: false}))
  //   }

  //   if (!customerInfo.fullName) {
  //     result = false;
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, fullNameError: true}))
  //   } else {
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, fullNameError: false}))
  //   }

  //   if (!customerInfo.email) {
  //     result = false;
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, emailError: true}))
  //   } else {
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, emailError: false}))
  //   }

  //   if (!customerInfo.phoneNumber) {
  //     result = false;
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, phoneNumberError: true}))
  //   } else {
  //     setCustomerInfoError((customerInfoError)=>({...customerInfoError, phoneNumberError: false}))
  //   }

  //   return result
  // }

  //update function for valid form
  const updateCustomerInfo = () => {

    // if (isValidForm()) {

      const newCustomerInfo = filterNonEmpty(customerInfo)
      delete newCustomerInfo.userId

      updateUserInfoByUserId({
        variables: {
          userId: customerInfo.userId,
          input: {
              fullName: customerInfo.fullName,
              email: customerInfo.email,
              phoneNumber: customerInfo.phoneNumber,
              dateOfBirth: customerInfo.dateOfBirth,
              organization: customerInfo.organization,
              travelDocumentType: customerInfo.travelDocumentType,
              travelDocumentNumber: customerInfo.travelDocumentNumber,
              streetAddress: customerInfo.streetAddress,
              streetAddressLine2: customerInfo.streetAddressLine2,
              city: customerInfo.city,
              province: customerInfo.province,
              postalCode: customerInfo.postalCode,
              country: customerInfo.country,
          }
        }
      }) 

      // updateTenantInfoByTenantId({
      //   variables: {
      //     tenantId,
      //     input: {
      //       travelDocumentNumber
      //       travelDocumentType
      //     },
      //   },
      // })

    // } else {
    //   const content = 'Please fill the form!'
    //   debouncedErrorMessage(content);
    // }
  }

  return {
    updateCustomerInfo,
    updateUserInfoLoading
  }
}
